import { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { coverageNavigationSearch, readCoverageNavigation, type CoverageView } from "./coverage-view-state";

/** Persist navigation only; never encode a person, site, draft or write target. */
export function useCoverageNavigation(enabled: boolean, fallbackDate: string, locked: boolean) {
  const [params, setParams] = useSearchParams();
  const [local, setLocal] = useState({ view: "staff" as CoverageView, date: fallbackDate });
  const requested = enabled ? readCoverageNavigation(params.toString(), fallbackDate) : local;
  const retained = useRef(requested);
  // Browser history may move while a panel is open. Apply its new browsing context after
  // dismissal, retaining the original target and pending receipt until then.
  if (!locked) retained.current = requested;
  const navigation = locked ? retained.current : requested;
  const browse = (view: CoverageView, date: string, fromPanel = false) => {
    if (locked && !fromPanel) return;
    retained.current = { view, date };
    if (enabled) setParams(previous => coverageNavigationSearch(previous.toString(), view, date));
    else setLocal({ view, date });
  };
  return { ...navigation, browse };
}
